import type { AiAppCenterModule } from '../types'

export const cmsModule: AiAppCenterModule = {
  key: 'cms',
  label: '内容管理',
  desc: '多站点 / 栏目分类 / 文章发布',
  path: '/cms',
  homePath: '/cms/dashboard',
  icon: 'ep:document',
  color: '#0ea5e9'
}
